import React from 'react';
import Heading from '../../../../generic-components/Heading';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';

export const LoadingToast = () => (
  <div className='fadeIn py-[8px] px-[12px] w-fit bg-[#20242E] bg-opacity-80 rounded-[4px] shadow-light flex items-center fixed bottom-0 z-[9999] left-[50%] translate-x-[-50%] translate-y-[-20px]'>
    <Heading title='Loading' className='font-metricR text-[12px] text-bw00 mr-[24px]' />
    <Spinner containerClassName='ml-auto' spinnerColor={SpinnerColor.White} height='1rem' width='1rem' />
  </div>
);
